import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { BaseTypographyConfig } from './BaseTypograhyConfig';

function BaseTypography({ children, variant, color, onClick, styles, ...props }) {
	return (
		<Typography
			variant={variant}
			color={color}
			onClick={onClick}
			sx={styles}
			// eslint-disable-next-line react/jsx-props-no-spreading
			{...props}
		>
			{children}
		</Typography>
	);
}

BaseTypography.defaultProps = {
	variant: BaseTypographyConfig.defaultVariantType,
	color: BaseTypographyConfig.defaultColor,
	onClick: null,
	styles: {},
	children: null,
};

BaseTypography.propTypes = {
	variant: PropTypes.oneOf(BaseTypographyConfig.baseTypographyVariants),
	color: PropTypes.string,
	onClick: PropTypes.func,
	styles: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])),
		PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
	]),
	children: PropTypes.node,
};

export default BaseTypography;
